import { useMemo } from 'react';

import { useSelectedStore } from '@/hooks';

import { SellTreezClient } from '../client';

const useSellTreezClient = () => {
  const { store } = useSelectedStore();

  const client = useMemo(
    () => new SellTreezClient(store?.mso_store_entity_id ?? ''),
    [store],
  );

  return client;
};

export { useSellTreezClient };
